import controller from './createDelegationHelp.controller.js';
import template from './createDelegationHelp.html';
import './createDelegationHelp.scss';

let createDelegationHelpComponent = {
  restrict: 'E',
  bindings: {
    delegationType : '<',
    module: '<'
  },
  template,
  controller,
};

export default createDelegationHelpComponent;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalCreateDelegation/createDelegationHelp/createDelegationHelp.component.js